/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Lot_Detail_Not_FoundInputs */

const vi_product_lot_detail_not_found = /** @type {(inputs: Product_Lot_Detail_Not_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy lô`)
};

/**

* @param {Product_Lot_Detail_Not_FoundInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_lot_detail_not_found = /** @type {((inputs?: Product_Lot_Detail_Not_FoundInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Lot_Detail_Not_FoundInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_lot_detail_not_found(inputs)
});